import {
  FocusProspectFilterId,
  FocusProspectFilterListResponse,
  FocusProspectFilterRequest,
  FocusProspectFilterResponse,
} from '@business/entities/focusMode';
import { Endpoint } from '../endpoint';

export function fetchProspectFilters() {
  return Endpoint.get<FocusProspectFilterListResponse>(`@gc/focus-prospect-filter`);
}

export function createProspectFilter(data: FocusProspectFilterRequest) {
  return Endpoint.post<{ filter: FocusProspectFilterResponse }>(`@gc/focus-prospect-filter/create`, { data });
}

export function updateProspectFilter(data: FocusProspectFilterRequest) {
  return Endpoint.post<{ filter: FocusProspectFilterResponse }>(`@gc/focus-prospect-filter/update`, { data });
}

export function deleteProspectFilter(id: FocusProspectFilterId) {
  return Endpoint.post<{ status: boolean }>(`@gc/focus-prospect-filter/delete`, { data: { id } });
}

export function saveProspectFilterOrder(ids: FocusProspectFilterId[]) {
  return Endpoint.post<FocusProspectFilterListResponse>(`@gc/focus-prospect-filter/order`, { data: { ids } });
}
